import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiServices } from "../4.Utils/apiServices";

const namespace = "ServiceLengths";

export const getServiceLengths = createAsyncThunk(
  `${namespace}/serviceLengths`,
  async (body, { rejectWithValue }) => {
    const api = "serviceLengthsList";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      console.log(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const addServiceLength = createAsyncThunk(
  `${namespace}/serviceLengthAdd`,
  async (body, { rejectWithValue }) => {
    const api = "serviceLengthAdd";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      console.log(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

//Delete Leave Entitles by ID
export const deleteServiceLength = createAsyncThunk(
  `${namespace}/deleteserviceLength`,
  async (body, { rejectWithValue }) => {
    const api = "serviceLengthDelete";
    const replace = { 
      search: "{id}",
      replace: body.id 
  };
  const opt = {
    replace: replace,
    body: body,
  };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  serviceLength: {
    id: "",
    description: "",
    status: "",
    short_description: ""
  },
  serviceLengths: [],
  loading: false,
  error: false,
};

const ServiceLengthsSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {
    updateserviceLength(state, action) {
      return { ...state, serviceLength: action.payload };
    },

    resetList(state) {
      return {
        ...state, 
        serviceLengths: initialState.serviceLengths,
        serviceLength: initialState.serviceLength
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getServiceLengths.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getServiceLengths.fulfilled, (state, action) => {
        state.loading = false;
        state.serviceLengths = action.payload;
        console.log(action.payload);
      })
      .addCase(getServiceLengths.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        console.error(action.payload);
      })

      .addCase(addServiceLength.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addServiceLength.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addServiceLength.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })

      .addCase(deleteServiceLength.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteServiceLength.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteServiceLength.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })
  },
});

export const { resetList, updateserviceLength } = ServiceLengthsSlice.actions;
export default ServiceLengthsSlice.reducer;